import {
  Cake,
  CircleAlert,
  ClipboardCheck,
  ClipboardList,
  Gift,
  HandCoins,
  Megaphone,
  MessageSquare,
  Receipt,
  Smartphone,
  UserCheck,
  UserPlus,
  Users,
  UsersRound,
} from 'lucide-react';
import type { ReactNode } from 'react';

export const DASHBOARD_METRIC_ICONS: Record<string, ReactNode> = {
  giving_in_period: <HandCoins className="size-5" aria-hidden />,
  gifts_in_period: <Gift className="size-5" aria-hidden />,
  online_gifts_in_period: <Smartphone className="size-5" aria-hidden />,
  active_members: <Users className="size-5" aria-hidden />,
  new_members_in_period: <UserPlus className="size-5" aria-hidden />,
  first_timers_in_period: <UserPlus className="size-5" aria-hidden />,
  open_follow_ups: <ClipboardList className="size-5" aria-hidden />,
  pending_member_requests: <UserCheck className="size-5" aria-hidden />,
  birthdays_today_count: <Cake className="size-5" aria-hidden />,
  messages_delivered_in_period: <MessageSquare className="size-5" aria-hidden />,
  campaigns_sent_in_period: <Megaphone className="size-5" aria-hidden />,
  delivery_failures_in_period: <CircleAlert className="size-5" aria-hidden />,
  check_ins_in_period: <ClipboardCheck className="size-5" aria-hidden />,
  unique_attendees_in_period: <UsersRound className="size-5" aria-hidden />,
  expenses_paid_in_period: <Receipt className="size-5" aria-hidden />,
  expenses_paid_count_in_period: <Receipt className="size-5" aria-hidden />,
  expenses_pending_approval: <ClipboardList className="size-5" aria-hidden />,
  active_groups: <UsersRound className="size-5" aria-hidden />,
  group_memberships: <Users className="size-5" aria-hidden />,
  pending_group_requests: <UserCheck className="size-5" aria-hidden />,
};
